export const THEME_BORDER_RADIUS = 8;
export const VALIDATION_VARIANTS = [
    'error',
    'warning',
    'underwriting'
];
export const radius = (number)=>number * THEME_BORDER_RADIUS;
